import { marked } from 'marked'
import DOMPurify from 'dompurify'

/**
 * Render announcement Markdown to sanitized HTML.
 * marked → HTML, then DOMPurify strips anything unsafe (scripts/handlers) while
 * allowing inline media (img/video) per the announcement design.
 */
export function renderAnnouncementMarkdown(md: string | null | undefined): string {
  if (!md) return ''
  const raw = marked.parse(md, { async: false }) as string
  return DOMPurify.sanitize(raw, {
    ADD_TAGS: ['video', 'source', 'iframe'],
    ADD_ATTR: ['controls', 'poster', 'target', 'allowfullscreen', 'frameborder'],
    FORBID_TAGS: ['script', 'style'],
  })
}
